// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__B5ohr","signatureButtonsRight":"ModalSign_signatureButtonsRight__1OAdY"};